/** Same local calendar as the label date formatter; date-only values must not
 * shift to the previous day in a negative UTC offset. Never invent a missing day. */
export function expiryWeekday(value: unknown): string | null {
  if (typeof value !== 'string' || !value.trim()) return null;
  const dateOnly = /^\d{4}-\d{2}-\d{2}$/.test(value);
  const date = new Date(dateOnly ? `${value}T12:00:00` : value);
  if (!Number.isFinite(date.getTime())) return null;
  if (dateOnly && `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}` !== value) return null;
  return ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'][date.getDay()] ?? null;
}

export function drawExpiryWeekday(
  ctx: CanvasRenderingContext2D, day: string, x: number, y: number, width: number, height: number,
): void {
  ctx.save();
  ctx.fillStyle = '#000';
  ctx.fillRect(x, y, width, height);
  ctx.fillStyle = '#fff';
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.font = `bold ${Math.min(width * 0.8, height * 0.62)}px Arial, sans-serif`;
  ctx.fillText(day[0]!, x + width / 2, y + height * 0.37, width * 0.88);
  ctx.font = `bold ${Math.min(width * 0.3, height * 0.24)}px Arial, sans-serif`;
  ctx.fillText(day.slice(1).toLowerCase(), x + width / 2, y + height * 0.82, width * 0.88);
  ctx.restore();
}
